import type { Trigger, PopupInstance, TriggerConfig } from '../types';

export class TimeoutTrigger implements Trigger {
	private timerId: ReturnType<typeof setTimeout> | null = null;

	init(popup: PopupInstance, config: TriggerConfig): void {
		let delayMs = config.delay * 1000;
		if (config.delayUnit === 'ms') {
			delayMs = config.delay;
		}

		this.timerId = setTimeout(() => {
			popup.show();
		}, delayMs);
	}

	destroy(): void {
		if (this.timerId !== null) {
			clearTimeout(this.timerId);
			this.timerId = null;
		}
	}
}
